import BigNumber from "bignumber.js";
import { PropsWithClassName, cn, fAmount } from "kz-ui-sdk";
import { useMemo } from "react";
import styles from "./PrizeAmount.module.css";

interface PrizeAmountProps extends PropsWithClassName {
  amount: number | BigNumber | undefined;
  shiny?: boolean;
  variant?: "static" | "animated";
  fontSize?: string | number;
}

const PrizeAmount = ({ className, amount, shiny, variant = "animated", fontSize }: PrizeAmountProps) => {
  const amountText = useMemo(
    () =>
      fAmount(amount, {
        abbreviate: true,
      }),
    [amount],
  );

  const effectiveVariant = shiny !== undefined ? (shiny ? "animated" : "static") : variant;

  return (
    <span
      className={cn(
        styles.prizeAmount,
        [effectiveVariant === "animated" && styles.prizeAmountAnimated],
        [effectiveVariant === "static" && styles.prizeAmountStatic],
        "inline-block",
        className,
      )}
      style={{ fontSize }}
      data-text={amountText}
    >
      {amountText}
    </span>
  );
};

export default PrizeAmount;
